<div class="select-tool">
  {{#if config.label}}
    {{> elements/_page_builder_label label=config.label description=config.description }}
  {{/if}}
  {{sp_select_tag "" class="tool-field" choices=selectItems selected=context searchable=config.select_searchable}}

  {{> elements/_hint hint=config.hint}}

  <div class="customized shared-component-options">
    <a href="" class="reset">{{{ icon "close-alt-color" }}} Remove Override</a>
  </div>
</div>
